import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useKgbListModel} from "@/stores/models/kgb-list-model";

export const useKgbListStore  = defineStore(
    'kgbListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceKgbList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useKgbListModel().kgbListCustomStore,
            })
        );

        // const dataSourceKgbList = (additionalParams = null) => {
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return useKgbListModel().kgbListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceKgbList.value.reload();
        };

        const initialized = ()=>{     
            dataSourceKgbList.value.reload();
        };

        

        return {
            dataSourceKgbList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);